import { actions } from './Reducer';
/**
 * Actions that fire saga watchers
 */

// singular

export const getArtisanStatsAction = id => {
  return {
    type: actions.GET_ARTISAN_STATS,
    payload: {
      id
    }
  };
};
export const getSupplierStatsAction = id => {
  return {
    type: actions.GET_SUPPLIER_STATS,
    payload: {
      id
    }
  };
};
export const getSuperStatsAction = id => {
  return {
    type: actions.GET_SUPER_STATS,
    payload: {
      id
    }
  };
};
export const getAdminStatsAction = id => {
  return {
    type: actions.GET_ADMIN_STATS,
    payload: {
      id
    }
  };
};
export const getCustomerStatsAction = id => {
  return {
    type: actions.GET_CUSTOMER_STATS,
    payload: {
      id
    }
  };
};
/**
 * Actions that are fired by redux-saga watchers
 */

// singular
export const createArtisanStatsSuccessAction = stats => ({
  type: actions.GET_ARTISAN_STATS_SUCCESS,
  payload: stats
});
export const createSupplierStatsSuccessAction = stats => ({
  type: actions.GET_SUPPLIER_STATS_SUCCESS,
  payload: stats
});
export const createAdminStatsSuccessAction = stats => {
  return {
    type: actions.GET_ADMIN_STATS_SUCCESS,
    payload: stats
  };
};
export const createSuperStatsSuccessAction = stats => ({
  type: actions.GET_SUPER_STATS_SUCCESS,
  payload: stats
});
export const createCustomerStatsSuccessAction = stats => ({
  type: actions.GET_CUSTOMER_STATS_SUCCESS,
  payload: stats
});

// Plural

/**
 * Misc
 */
export const setStatsLoadingAction = isLoading => ({
  type: actions.SET_STATS_IS_LOADING,
  payload: isLoading
});
